import FieldsConstants from '../common/fields.constants';
import FieldAllowedAttributeTypes from '../forms/fields/field-allowed-attribute-types.values';
import FieldAllowedValueClasses from '../forms/fields/field-allowed-value-classes.values';
import { FormTypes } from '../forms/forms.enum';
import { Attribute } from '../interfaces/form-and-field.interface';

export const verificationCodeMock: Attribute = {
  name: 'verification_code',
  value_class_front: FieldAllowedValueClasses.VERIFICATION_CODE,
  min_length: FieldsConstants.MAX_MIN_VERIFICATION_CODE_LEN,
  max_length: FieldsConstants.MAX_MIN_VERIFICATION_CODE_LEN,
  type_attribute: FieldAllowedAttributeTypes.TEXT,
  required: true,
  read_only: false,
  label: '',
  placeholder: '',
  security: true,
  scheme_name: FormTypes.SECOND_AUTH_LEVEL,
};

export const phoneNumberMock: Attribute = {
  name: 'phone_number',
  value_class_front: FieldAllowedValueClasses.PHONE_2FA,
  min_length: 1,
  max_length: 15,
  type_attribute: FieldAllowedAttributeTypes.TEXT,
  required: true,
  read_only: false,
  label: 'Phone number',
  placeholder: 'Enter your phone number',
  security: false,
  scheme_name: FormTypes.SECOND_AUTH_LEVEL,
};
